$(document).ready(function () {

	// console.log('--> doc ready')

	//
	// On donne le focus à la fenetre du site et non au navigateur
	//
	$(window).focus()

	// init skip_link
	fn_nav_skip()

	// init scroll_top
	fn_scroll_top()

	// IE detection
	// See: detectizr
	// for each browser state the minimum version your project suppports
	// > see: https://caniuse.com/#feat=flexbox
	var browserSupport = {
		safari: 9,
		edge: 12,
		ie: 10,
		chrome: 42,
		firefox: 35,
		opera: 28
	}
	var currentPageUrl = window.location.href;
	var browserName = String(Detectizr.browser.name)
	var browserVersion = parseInt(Detectizr.browser.version)
	var browserMessage = '<div class="alert--browser alert alert-warning alert-dismissible show" role="alert"> \
                    <p lang="fr">Ce site requiert un navigateur plus récent (Microsoft Internet Explorer 10 minimum). SVP, mettez-le &agrave; jour.</p> \
                    <p lang="en">This website requires a newer browser (Microsoft Internet Explorer browser 10 at least); please update.</p> \
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> \
                    </div>'
	setTimeout(function () {
		//
		if (browserSupport.hasOwnProperty(browserName)) {
			var minVersion = browserSupport[browserName]
			if (browserVersion < minVersion) {
				$(document).ready(function () {
					//
					$('body').prepend(browserMessage)
					//
				})
			}
		}
		//
	}, 500)
	//

	// Smooth scroll for in page links
	$('a[href*="#"]:not([href="#"]):not([role="tab"]):not([data-toggle="lightbox"]):not([data-toggle="collapse"]):not(.carousel-control):not(.sr-only-focusable)').click(function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash)
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top - 130
				}, 1000)
				return false
			}
		}
	})
	//

	// MMENU menu
	$("#navigation_section_mobile").mmenu({
		offCanvas: {
			position: "right",
		}
	});
	var API = $("#navigation_section_mobile").data("mmenu");
	$(".btn.toggle-mobile-menu").click(function () {
		API.open();
	});


	// fn_header_h
	// > header Height calculation when with / whithout nav as navigation is positionned absolute
	//
	// height_header => Top wrapper: header
	// header_x_nav => Top wrapper + Nav L1 Height
	//
	var fn_header_h = function () {

		var body = $('body');
		var main = $('.body-wrapper.mm-page');
		var main_x_nav = $('.body-wrapper.mm-page.page-has-menu-desktop');
		var main_mobile = $('.mm-page__wrapper.mm-page');

		var height_header = $('.js .top-wrapper').outerHeight(true);
		var nav_height = $('.js .nav-is-level1').outerHeight(true);

		var header_x_nav = height_header + nav_height + 16;

		// + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + +
		//
		// Setting up at page loading time and getting heights of required elts / outerHeight
		//
		// + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + +
		var fn_position_top = function () {

			if (Modernizr.mq('all and (max-width: 999px)')) {
				// Adding class Small Screens
				main.css('padding-top', '0');
				main_mobile.css('padding-top', height_header);
				//
			} else {
				// Adding class for Desktop like screens
				main_mobile.css('padding-top', '0');
				main.css('padding-top', height_header);
				main_x_nav.css('padding-top', header_x_nav);

				//
			}

		}

		fn_position_top();


		// + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + +
		//
		// At page resizing, we relaunch calculation
		//
		// + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + +
		$(window).on('load, resize', function () {
			fn_position_top();
		});

	};
	fn_header_h();
	//
	//

	// Fn Search Collapse
	var fn_search_c = function () {

		// Fn Checking Screen Sizes
		function checkMqDevice() {
			// RWD 767 breakpoint checking
			if (Modernizr.mq('all and (max-width: 999px)')) {
				// non desktop RWD
				$('#search-global__wrapper').collapse('hide');

				//
			} else {
				// desktop RWD

				//
			}

			//
		}
		//
		// Screen Sizes checking Fn
		checkMqDevice();

		$(window).on('load, resize', function () {
			checkMqDevice();
		});

	};
	fn_search_c();


	// init Slick Slider Hero
	// > Slider HERO
	$('.slider-hero').each(function (key, item) {
		var sliderIdName = 'slider-hero' + key

		$(this).find('.slider-list').attr('id', sliderIdName)

		var sliderId = '#' + sliderIdName

		$(sliderId).on('init', function (event, slick) {
			$(this).parent('.slider-wrapper').removeClass('slider-loading')
		})

		$(sliderId).slick({
			slide: '.slider-item',
			infinite: true,
			centerMode: false,
			// centerPadding: '20%',
			slidesToShow: 1,
			touchEnabled: true,
			fade: false,
			arrows: true,
			dots: true,
			autoplay: true,
			autoplaySpeed: 5000, // was 3000
			adaptiveHeight: true,
			prevArrow: '<button type="button" data-role="none" class="slick-btn slick-prev" aria-label="Précédente image">Précédente image</button>',
			nextArrow: '<button type="button" data-role="none" class="slick-btn slick-next" aria-label="Image suivante">Image suivante</button>',
			responsive: [{
					breakpoint: 1200,
					settings: {
						// centerPadding: '10%'
					}
				},
				{
					breakpoint: 1100,
					settings: {
						arrows: false
						// centerMode: false,
						// centerPadding: '0%',
						// slidesToShow: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						arrows: false
						// ,
						// centerMode: false,
						// centerPadding: '0%',
						// slidesToShow: 1
					}
				}
			]

		})
	})
	//

	// WALL powered by PACKERY
	$('.wall__wrapper').each(function () {
		$wall = $(this)
		var elements = $wall.find('.wall__col').clone()
		$wall.find('.wall__col').remove()
		$wall.removeClass('wall__wrapper--hidden')
		// create packery
		var $container = $wall.packery({
			gutter: 0,
			itemSelector: '.wall__col',
			columnWidth: '.grid-sizer',
			rowHeight: 0,
			percentPosition: true
		})
		// append elts
		$container.append(elements)
		$container.packery('appended', elements)
	})

	// FN Video RWD
	$.fn.resizeEmbed = function (options) {
		var defaults = {}
		var options = $.extend(defaults, options)
		var obj = $(this)

		obj.each(function () {
			var newWidth = $(this).parent().width()
			$(this)
				// jQuery .data does not work on object/embed elements
				.attr('data-aspectRatio', this.height / this.width)
				.removeAttr('height')
				.removeAttr('width')
				.width(newWidth)
				.height(newWidth * $(this).attr('data-aspectRatio'))
		})

		$(window).on('resize', function () {
			obj.each(function () {
				var newWidth = $(this).parent().width()
				$(this)
					.width(newWidth)
					.height(newWidth * $(this).attr('data-aspectRatio'))
			})
		})

		return this
	}
	// Video RWD (+ wysiwyg__wrapper iframe)
	$('.has-video iframe').resizeEmbed();
	// Testing .wysiwyg__wrapper iframe[src^='//player.vimeo.com'], .wysiwyg__wrapper iframe[src^='//www.youtube.com']
	$(".wysiwyg__wrapper iframe").resizeEmbed();

	// Datepicker
	$('.input-group.date').datepicker({
		leftArrow: '<i class="fa fa-long-arrow-left"></i>',
		rightArrow: '<i class="fa fa-long-arrow-right"></i>',
		maxViewMode: 2,
		todayBtn: true,
		// clearBtn: true,
		language: 'fr',
		multidate: true,
		daysOfWeekDisabled: '1',
		calendarWeeks: true,
		todayHighlight: true,
		startView: 1

	})

	// Clickable TR
	$('.table--has-link tr').click(function () {
		var href = $(this).find('a').attr('href')
		if (href) {
			window.location = href
		}
	})

	// Switchable Buttons - see FAQ
	$('.js-btn-group-toggler').on('click', '.btn-t-1', function () {
		// console.log($(this))
		$('#btn-t-2_collapsable').collapse('hide')
		$(this).addClass('active').button('toggle')
	})
	$('#btn-t-2_collapsable').on('shown.bs.collapse', function () {
		// do something…
		$(this).siblings('.js-btn-group-toggler').find('.btn-t-1').button('toggle')
	})
	$('#btn-t-2_collapsable').on('hidden.bs.collapse', function () {
		// do something…
		$(this).siblings('.js-btn-group-toggler').find('.btn-t-1').button('toggle')
	})

	// Tabel Sorter
	$(function () {
		$(".table--sortable").tablesorter({
			// header layout template (HTML ok); {content} = innerHTML,
			// {icon} = <i/> (class from cssIcon)
			headerTemplate: '{content}{icon}'
		});
	});

	// Search bar set focus
	$('#search-global__wrapper').on('shown.bs.collapse', function () {
		$('#f-search-global').focus();
	});

	// Replacing link by youtube video embed
	$('a.youtubevid').click(function () {
		width = '100%';
		height = '100%';
		vcode = $(this).attr('href').replace('#', '');
		style = "position: absolute; top: 0; left: 0; border: 0;";

		$(this).html('<div class="video__figure"><iframe width="' + width + '" height="' + height + '" style="' + style + '" src="https://www.youtube-nocookie.com/embed/' + vcode + '?autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen wmode="Opaque"></iframe></div>');

		$("head > style").append('div.video__figure::after{ content: none;}'); // cancelling the fa-icon display


		return false;
	});

	// Waypoint
	var f_toolbar = $('.f-toolbar__wrapper').parent('.f-toolbar-container')

	var inview = new Waypoint.Inview({
		element: $('#footer')[0],
		enter: function (direction) {
			f_toolbar.addClass('no-fix')
		},
		exited: function (direction) {
			f_toolbar.removeClass('no-fix')
		}
	})

	// Fixing bug of accordions toggling
	$(' a[data-toggle="collapse"] ').on('webkitTransitionEnd transitionend', function () {
		/* console.log('toto') */
		Waypoint.refreshAll()
	})


	// Fn Sticky Header
	var fn_stickynav = function () {

		// Fn Checking Screen Sizes
		function checkMqDevice() {
			// RWD 767 breakpoint checking
			if (Modernizr.mq('all and (max-width: 999px)')) {
				// non desktop RWD
				//
			} else {
				// desktop RWD
				// Affix NAV
				$(".top-wrapper").affix({
					offset: {
						top: $(".top-wrapper").outerHeight(true) / 2
					}
				});
				//
			}

			//
		}
		//
		// Screen Sizes checking Fn
		checkMqDevice();

		$(window).on('load, resize', function () {
			checkMqDevice();
		});

	};
	fn_stickynav();
	// //


	// Fn Table RWD
	// MOD - based on: http://zurb.com/playground/playground/responsive-tables/responsive-tables.js
	$.fn.tableRwd = function (options) {
		var defaults = {
			breakpoint: 991
		};
		var options = $.extend(defaults, options);
		var obj = $(this);

		var switched = false;
		var updateTables = function () {
			if (($(window).width() < options.breakpoint) && !switched) {
				switched = true;
				obj.each(function (i, element) {
					if (!element.parent().hasClass('tableau_responsive_vert')) {
						console.log('no class tableau_responsive_vert', element.parent());
						splitTable($(element));
					} else {
						console.log('has class tableau_responsive_vert', element.parent());
					}
				});
				return true;
			} else if (switched && ($(window).width() > options.breakpoint)) {
				switched = false;
				obj.each(function (i, element) {
					unsplitTable($(element));
				});
			}
		};

		$(window).on('load, resize', function () {
			updateTables();
		});

		function splitTable(original) {
			original.css("margin", 0).wrap(
				$("<div class='table-responsive'></div>").css({
					"overflow-x": "scroll",
					"overflow-y": "visible"
				})
			);
		}

		function unsplitTable(original) {
			original.css("margin", "")
			original.unwrap();
		}

		return this;
	};
	//
	$(".wysiwyg__wrapper table").tableRwd({
		breakpoint: 999
	});
	// //


	// Fn SVG external to inline
	// See: https://medium.com/@asadalikanwal/controlling-svg-via-css-for-transitions-and-hover-effects-fcd9b48a4562
	/*
	 * Replace all SVG images with inline SVG
	 */
	$(function () {
		// $('.nav-tabs__figure img').each(function () {
		$('img[src$=".svg"]').each(function () {
			var $img = $(this);
			var imgID = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL = $img.attr('src');
			$.get(imgURL, function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');
				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}
				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
				// Replace image with new SVG
				$img.replaceWith($svg);
			}, 'xml');
		});
	})
	// //

	//

	//
	function scrollFormIntoView() {
		var form = document.getElementById("collapseForm");
		var form_trigger = $("[aria-controls='collapseForm']");

		if (form && form_trigger) {
			var hr = document.getElementsByClassName("hr")[1];

			if (form_trigger.attr('aria-expanded')) {
				form_trigger.click(function () {
					hr.scrollIntoView({
						behavior: "smooth",
						block: "center"
					});
				});
			}
		}
	}

	scrollFormIntoView();



	if (currentPageUrl.indexOf("/definition/") > -1) {
		setLexiqueInDefinition();
	}

	// init tooltip
	$('[data-toggle="tooltip"]').tooltip();

	// init simulateur
	fn_simulateur()
})

//Permet de changer le localastorage de la lettre quand on clique sur une lettre depuis une définition
function setLexiqueInDefinition() {

	// Sélectionne tous les liens avec la classe "lnletter-lexique"
	var liens = $('.lnletter-lexique');

	if (liens.length>0) {
		// Ajoute un gestionnaire d'événements pour le clic à chaque lien
		liens.click(function () {
			// Récupère l'ID de l'objet
			var id = $(this).attr('id');

			// Splite l'ID par '-'
			var parties = id.split('-');

			// Récupère la deuxième partie du string
			var deuxiemePartie = parties[1];

			// Stocke la deuxième partie dans sessionStorage
			sessionStorage.setItem('cmtt_last_letter', deuxiemePartie.toUpperCase());
		});
	}
}